import {createContext} from 'react'

import type {ExposeFolderFragment} from '@sdox/api'

// This context has to be defined in its on file as a workaround for a vite HMR bug.
//  When the context is defined in the ./useFolderFragment file, the context value will be null on hot reload
//  According to GitHub issues this should be fixed, but it does not work for us:
//  GitHub Issue: https://github.com/vitejs/vite/issues/3301
//  GitHub PR: https://github.com/vitejs/vite/pull/10239
export const ExposeFolderContext = createContext<ExposeFolderFragment>(null!)
